import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Cash Lock"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-cash-lock',
    templateUrl: './icon-cash-lock.component.html',
    styleUrls: ['./icon-cash-lock.component.scss'],
    standalone: false
})
export class IconCashLockComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
